<template>
  <div class="my-vacancies-list">

      <div v-if="pending" class="page__columns-inner container-inner">
        <div class="page__main-col">
          <BasePreloader/>
        </div>
      </div>

      <div v-else-if="vacancies.length">
        <div class="my-vacancies-list__inner">
          <VacancyCard v-for="item in vacancies"
                       :key="item.id"
                       :vacancy="item"
                       class="recommended-vacancies__item"
          />
        </div>
       <!---->

      </div>
      <div v-else>{{$tVacancies('Vacancies not found')}}</div>
  </div>
</template>

<script>
  import {http} from "../axios"
  import VacancyCard from "./VacancyCard";

  export default {
    name: "RecommendedVacanciesList",
    components: {
      VacancyCard
    },
    data() {
      return {
        timer: null,
        pending: false,
        vacancies: []
      }
    },
    computed: {

    },
    methods: {
      load() {
        this.pending = true

        http.get('/api/cabinet/recommended-vacancies').then(({data}) => {
            this.vacancies = data.data
        }).finally(() => {this.pending = false})
      },
    },
    created() {
      this.load()
    }
  }
</script>

<style lang="less">

</style>
